import * as React from 'react';
export var TabsContext = React.createContext({
  variant: 'default',
  mountOnEnter: false,
  unmountOnExit: false,
  localActiveKey: '',
  uniqueId: '',
  handleTabClick: function handleTabClick() {
    return null;
  }
});
export var TabsContextProvider = TabsContext.Provider;
export var TabsContextConsumer = TabsContext.Consumer;